import { render, staticRenderFns } from "./ItemCard.vue?vue&type=template&id=112fcd3c&scoped=true&"
import script from "./ItemCard.vue?vue&type=script&setup=true&lang=js&"
export * from "./ItemCard.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./ItemCard.vue?vue&type=style&index=0&id=112fcd3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112fcd3c",
  null
  
)

export default component.exports
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QItem,QItemSection,QImg,QItemLabel,QBtn,QIcon});
